// extracted by mini-css-extract-plugin
export default {"overlay":"cD-z","bodyOpen":"dD-z","content":"eD-z","header":"fD-z","close":"gD-z","closeNoHeading":"hD-z"};